export const MAX_CHARS_ISSUE_TEXT = 50;
export const MAX_CARS_SUMMARY_ALLOWED = 200000;
export const PRE_QC_DOCUMENT_TYPE_TRANSCRIPT_JSON = 'transcript_json';
export const PRE_QC_DOCUMENT_TYPE_SUBTITLES_JSON = 'subtitles_json';